<template>
  <div>
    <div class="pb-5" data-wizard-type="step-content">
      <div class="row">
        <div class="col-xl-12">
          <h4 v-if="course.id">Saisissez les informations à modifier</h4>

          <h4 v-else class="mb-10 font-weight-bold text-dark">
            Saisissez les informations à créer en Anglais
          </h4>
          <div class="form-group">
            <v-text-field
              :rules="titleErrors"
              :counter="150"
              type="text"
              v-model="course.titleEN"
              label="Titre du parcours en anglais *"
            />
          </div>
          <div class="form-group">
            <v-textarea
              :rules="descErrors"
              v-model="course.descriptionEN"
              label="Description du parcours en anglais *"
              
            />
          </div>
          <!-- <div class="form-text">Tags / Mots-clés du parcours</div>
          <div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <label><i class="la la-eye"></i> Visibles</label>

                <v-combobox
                  v-model="course.keywords.visibleEN"
                  :items="keywords.visibleEN"
                  label="Tags visibles"
                  multiple
                  chips
                  item-text="name"
                  return-object
                  clearable
                  deletable-chips
                  hide-selected
                  :rules="[required]"
                  ><template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title>
                        Mot-clé inexistant. Appuyer sur Entrer pour
                        <strong>le créer</strong>
                      </v-list-item-title>
                    </v-list-item>
                  </template></v-combobox
                >
              </div>
            </div>
            <div class="col-xl-6">
              <div class="form-group">
                <label><i class="la la-eye-slash"></i> Invisibles</label>

                <v-combobox
                  v-model="course.keywords.invisibleEN"
                  :items="keywords.invisibleEN"
                  label="Tags invisibles"
                  multiple
                  chips
                  item-text="name"
                  return-object
                  clearable
                  deletable-chips
                  hide-selected
                  :rules="[required]"
                  ><template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title>
                        Mot-clé inexistant. Appuyer sur Entrer pour
                        <strong>le créer</strong>
                      </v-list-item-title>
                    </v-list-item>
                  </template></v-combobox
                >
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/core/services/api.service";

export default {
  name: "formCourseStep2",

  model: {
    prop: "course",
    event: "input",
  },
  props: {
    course: Object,
  },
  data: () => ({
    titleErrors: [
      (v) => !!v || "Le titre du parcours est obligatoire.",
      (v) => v.length >= 2 || "Le titre doit être supérieur à 2 caractères",
    ],
    descErrors: [
      (v) => !!v || "La description du parcours est obligatoire.",
      (v) =>
        v.length >= 2 || "La description doit être supérieure à 2 caractères",
    ],
    keywords: {
      visibleEN: [],
      invisibleEN: [],
    },
  }),
  mounted() {
    this.getKeywords();
    this.isEditing();
  },
  methods: {
    isEditing() {
      if (this.course.id) {
        this.className = "col-xl-9";
      }
      else{
        this.className = "col-xl-12"
      }
    },
    required(value) {
      if (value instanceof Array && value.length == 0) {
        return "Vous devez choisir ou créer un mot-clé";
      }
      return !!value || "Vous devez choisir ou créer un mot-clé";
    },
    getKeywords() {
      Api.get("keywords").then((keywords) => {
        keywords.data["hydra:member"].forEach((keyword) => {
          if (keyword.isVisible == true) {
            if (keyword.lang === "EN") {
              // Je range tout les mots-clés dans un tableau pour savoir s'ils sont visibles ou non
              this.keywords.visibleEN.push(keyword);
            }
          } else {
            if (keyword.lang == "EN") {
              this.keywords.invisibleEN.push(keyword);
            }
          }
        });
        
      });
    },
  },
};
</script>
